import React, { useState } from 'react';

// ------------------ COMPONENTES DE PRIMEREACT--------------------------
import { Button } from 'primereact/button';
import { Calendar } from 'primereact/calendar';
import { InputText } from 'primereact/inputtext';
import { InputNumber } from 'primereact/inputnumber';
import { SplitButton } from 'primereact/splitbutton';
import { InputTextarea } from 'primereact/inputtextarea';

// ------------------ COMPONENTES DE BASE--------------------------------
import AutoCompleteDropdown from '../../../../../Base/Components/Form/AutoCompleteDropdown';

// ------------------ COMPONENTES DE NECESARIOS--------------------------
import './EncabezadoOrdenes.scss';
import RequisasOverlayPanel from './RequisasOverlayPanel';
import OrdenesComprasReporte1 from '../Reporte/OrdenesComprasReporte1';

const EncabezadoOrdenesCompras = ({ values, handleInputChange, habilitar, Functions, setNumber, inputValues, botonReporteHabilitado, detalleOrdenCompra}) => {
  const { guardarEncabezado, editarEncabezado } = Functions;
  const [selectedProveedor, setSelectedProveedor] = useState(null);
  const [selectedMoneda, setSelectedMoneda] = useState(null);
  const [selectedPcs, setSelectedPCs] = useState([]);
  const [showReporte, setShowReporte] = useState(false);
  const [Languaje, setLanguaje] = useState('es');

  // Cambio para listado de requisa
  const handleProveedorChange = (selectedValue) => {
    setSelectedProveedor(selectedValue);
  };

  // Cambio para listado de requisa
  const handleMonedaChange = (selectedValue) => {
    setSelectedMoneda(selectedValue);
  };

  // Función para manejar el clic en el botón para guardar o editar una orden
  const handleClick = () => {
    if (values.IdPurchaseOrder === -1) {
      guardarEncabezado();
    } else if (values.IdPurchaseOrder) {
      editarEncabezado();
    }
  };

  const items = [
    {

      className:"p-componentt",
      label: "Ingles",
      icon: '',
      command: () => {
        setShowReporte(true)
        setLanguaje('en')
      },
    },
    {
   
      label: "Español",
      icon: '',
      command: () => {
        setShowReporte(true)
        setLanguaje('es')
      },
    },
  ];

  return (
    <div className="flex justify-content-center">
      <form id="formularioOrdenCompra" autoComplete="off">
        <div style={{ display: "none" }}>
          <input
            type="text"
            id="PreventChromeAutocomplete"
            name="PreventChromeAutocomplete"
            autoComplete="cc-name"
          />
          <input
            name="ccname"
            id="frmNameCC"
            required
            placeholder="Full Name"
            autoComplete="cc-name"
          />

          <input
            name="cardnumber"
            id="cardnumber"
            required
            autoComplete="cc-number"
          />
          <input name="expire" id="cardexpire" required autoComplete="cc-exp" />

          <input name="cvc" id="frmCCCVC" required autoComplete="cc-csc" />
        </div>

        {/* Encabezado */}
        <div className="encabezado__Contenedor_OrdenCompra">
          <div className="p-float-label">
            <InputText
              type="text"
              value={values.NumeroOrden}
              onChange={e => handleInputChange(e, "NumeroOrden")}
              style={{ fontWeight: "bold", fontSize: "small" }}
              onKeyDown={(e) =>
                e.keyCode === 13 ? Functions.getInfo(values.NumeroOrden) : null
              }
            />
            <label htmlFor="No. Orden">No. Orden</label>
            <Button
              icon="pi pi-search"
              type="button"
              className="p-button-info "
              onClick={(e) => Functions.getInfo(values.NumeroOrden)}
              id="#buscarOC"
              tooltip="Buscar Orden"
              tooltipOptions={{
                className: "purple-tooltip",
                position: "top",
              }}
            />
          </div>

          <div className="p-float-label Date encabezado__contenido">
            <Calendar
              id="Date"
              name="Date"
              disabled
              value={values.Date}
              onChange={handleInputChange}
              dateFormat="dd/mm/yy"
              mask="99/99/9999"
              showIcon
            />
            <label htmlFor="Date">Fecha</label>
          </div>

          <AutoCompleteDropdown
            enable={false}
            value={values.Estado}
            items={inputValues.Estados}
            field={"StatusName"}
            name={"Estado"}
            handleInputChange={handleInputChange}
          />

          <AutoCompleteDropdown
            enable={habilitar}
            value={values.Agente}
            items={inputValues.AgentesCompras}
            field={"UserNameAgente"}
            name={"Agente"}
            label={"Agente"}
            handleInputChange={handleInputChange}
            tabIndex={3}
          />

          {/* <AutoCompleteDropdown
            enable={habilitar}
            value={values.Cliente}
            items={inputValues.Clientes}
            field={"CustomerName"}
            name={"Cliente"}
            handleInputChange={handleInputChange}
          />

          <AutoCompleteDropdown
            enable={!!values.Cliente && habilitar}
            value={values.ClienteDetalle}
            items={inputValues.ClientesDetalle}
            field={"Address"}
            name={"ClienteDetalle"}
            handleInputChange={handleInputChange}
            label={"Entregar A"}
            filterValue={values?.Cliente}
            itemsFilter={(e) => {
              if (!inputValues.ClientesDetalle) {
                return [];
              }
              return inputValues.ClientesDetalle.filter(
                (s) => s.IdCustomer === values?.Cliente?.IdCustomer
              );
            }}
            itemTemplate={(e) => {
              return (
                <div className="d-flex">
                  <div className="pe-2">{e.Address + " | "}</div>
                  <div className="pe-2">{e.CompanyName + " | "}</div>
                  <div className="pe-2">{e.Country}</div>
                </div>
              );
            }}
          /> */}

          <AutoCompleteDropdown
            enable={habilitar && !detalleOrdenCompra?.length > 0}
            value={values.Proveedor}
            items={inputValues.Proveedores}
            field={"CustomerName"}
            name={"Proveedor"}
            handleInputChange={handleInputChange}
            tabIndex={1}
            onValueChange={handleProveedorChange}
          />

          <AutoCompleteDropdown
            enable={habilitar}
            value={values.TipoCompra}
            items={inputValues.TipoCompras}
            field={"Type"}
            name={"TipoCompra"}
            handleInputChange={handleInputChange}
            tabIndex={5}
            label={"Tipo Compra"}
          />

          <AutoCompleteDropdown
            enable={habilitar}
            value={values.Termino}
            items={inputValues.Terminos}
            field={"Term"}
            name={"Termino"}
            label={"Térm. Compras"}
            handleInputChange={handleInputChange}
            tabIndex={4}
          />

          <AutoCompleteDropdown
            enable={habilitar}
            value={values?.TerminoInco}
            items={inputValues.TerminosInco}
            field={"Term"}
            name={"TerminoInco"}
            label={"Térm. Inco"}
            handleInputChange={handleInputChange}
          />

          <AutoCompleteDropdown
            enable={habilitar && !detalleOrdenCompra?.length > 0}
            value={values?.Moneda || values?.Currency}
            items={inputValues.Monedas}
            field={"Currency"}
            name={"Moneda"}
            label={"Moneda"}
            handleInputChange={handleInputChange}
            onValueChange={handleMonedaChange}
          />

          <AutoCompleteDropdown
            enable={habilitar}
            value={values.Area}
            items={inputValues.Areas}
            field={"Area"}
            name={"Area"}
            handleInputChange={handleInputChange}
            label={"Área"}
          />

          <div className="encabezado__contenido RequiredDate p-float-label">
            <Calendar
              id="RequiredDate"
              name="RequiredDate"
              disabled={!habilitar}
              value={values.RequiredDate}
              onChange={(e) => handleInputChange(e, "RequiredDate")}
              dateFormat="dd/mm/yy"
              mask="99/99/9999"
              showButtonBar
              showIcon
              tabIndex={9}
            />
            <label htmlFor="TipoCompra">Req. Desde</label>
          </div>

          <div className="encabezado__contenido RequiredDateH p-float-label">
            <Calendar
              id="RequiredDateH"
              name="RequiredDateH"
              disabled={!habilitar}
              value={values.RequiredDateH}
              onChange={(e) => handleInputChange(e, "RequiredDateH")}
              dateFormat="dd/mm/yy"
              mask="99/99/9999"
              yearRange="2010:2030"
              monthNavigator
              showButtonBar
              yearNavigator
              showIcon
            />
            <label htmlFor="TipoCompra">Req. Hasta</label>
          </div>

          <div className="p-float-label">
            <InputTextarea
              disabled={!habilitar}
              name="Comment"
              value={values.Comment}
              onChange={handleInputChange}
              autoResize={true}
              cols={73}
              placeholder
              className={"p-inputtext-sm block mb-2 mx-1 block"}
              yearNavigator
              yearRange="2010:2030"
              monthNavigator
            />
            <label htmlFor="TipoCompra">Comentario</label>
          </div>
        </div>

        {/* Herramientas */}
        <div className="encabezado__Contenedor_OrdenCompra">
          <div>
            <React.Fragment>
              <div className="d-flex align-items-center d-flex gap-1">
                <Button
                  icon="pi pi-plus"
                  disabled={!habilitar}
                  type="button"
                  className="p-button-info encabezado__herramienta-botones"
                  tooltip="Agregar items"
                  onClick={Functions.addNewRow}
                />
                <Button
                  icon="pi pi-save"
                  disabled={!habilitar}
                  type="submit"
                  className="p-button-primary encabezado__herramienta-botones"
                  onClick={handleClick}
                  tooltip="Guardar"
                  style={{ marginLeft: 1 }}
                />
                <Button
                  icon="pi pi-pencil"
                  type="button"
                  className="p-button-secondary  encabezado__herramienta-botones"
                  onClick={Functions.habilitarComponentes}
                  tooltip="Editar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                  disabled={values?.IdPurchaseOrder <= 0}
                />
                <Button
                  icon="pi pi-times"
                  type="button"
                  className="p-button-danger encabezado__herramienta-botones"
                  onClick={() => Functions.eliminarItemDetalle()}
                  tooltip="Eliminar"
                  disabled={!habilitar || detalleOrdenCompra?.length <= 0}
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />
                <div className="d-flex flex-row">
                  <SplitButton
                    disabled={!botonReporteHabilitado}
                    label=""
                    icon="pi pi-print"
                    onClick={(e) => {
                      // window.open(
                      //   `${process.env.REACT_APP_ENV}/OrdenCompras/print/${values?.NumeroOrden}/2`,
                      //   values?.NumeroOrden,
                      //   "height=1200,width=1000"
                      // )
                      setShowReporte(true)
                      setLanguaje('es')
                    }}
                    model={items}
                  />
                </div>

                <Button
                  icon="pi pi-book"
                  type="button"
                  className="p-button-info  encabezado__herramienta-botones"
                  onClick={Functions.nuevaRequisa}
                  tooltip="Nuevo"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />
                <Button
                  icon="pi pi-sync"
                  type="button"
                  className="p-button-info encabezado__herramienta-botones"
                  onClick={() => Functions.getInfo(values.NumeroOrden)}
                  tooltip="Cargar"
                  tooltipOptions={{
                    className: "purple-tooltip",
                    position: "top",
                  }}
                  style={{ marginLeft: 1 }}
                />
              </div>
            </React.Fragment>
          </div>

          {/* Bloque de Calculos */}
          <div className="d-flex bloqueCalculos">
            <span className="p-float-label">
              <InputNumber
                mode="decimal"
                currency="HNL"
                locale="en-US"
                minFractionDigits={2}
                maxFractionDigits={2}
                id="SubTotal"
                name="SubTotal"
                disabled
                value={values.SubTotal}
                onChange={setNumber}
              />
              <label id="label_comentario" htmlFor="SubTotal">
                SubTotal
              </label>
            </span>
            <span className=" p-float-label">
              <InputNumber
                mode="decimal"
                currency="HNL"
                locale="en-US"
                minFractionDigits={2}
                maxFractionDigits={2}
                id="Descuento"
                name="Descuento"
                disabled
                value={values.Discount}
                onChange={setNumber}
              />
              <label id="label_comentario" htmlFor="Descuento">
                Descuento
              </label>
            </span>
            <span className=" p-float-label">
              <InputNumber
                id="ISV"
                mode="decimal"
                locale="en-US"
                minFractionDigits={2}
                maxFractionDigits={2}
                name="ISV"
                disabled
                value={values.TAX}
                onChange={setNumber}
              />
              <label id="label_comentario" htmlFor="Tax">
                Tax
              </label>
            </span>

            <span className=" p-float-label">
              <InputNumber
                id="ISV18"
                mode="decimal"
                locale="en-US"
                minFractionDigits={2}
                maxFractionDigits={2}
                name="ISV18"
                disabled
                value={values.ISV18}
                onChange={setNumber}
              />
              <label id="label_comentario" htmlFor="Tax">
                ISV 18%
              </label>
            </span>

            <span className="p-float-label">
              <InputNumber
                mode="decimal"
                currency="HNL"
                locale="en-US"
                minFractionDigits={2}
                maxFractionDigits={2}
                disabled
                id="Total"
                name="Total"
                value={values.Total}
                onChange={setNumber}
              />
              <label id="label_comentario" htmlFor="Total">
                Total
              </label>
            </span>
          </div>

          {/* Listado de Requisas */}
          <div className="d-flex">
            <div className="d-flex align-items-center justify-content-center">
              <span className="p-float-label">
                <RequisasOverlayPanel
                  setNuevaFila={Functions.addRequisas}
                  selectedPcs={selectedPcs}
                  setSelectedPCs={setSelectedPCs}
                  IdMoneda={values.Moneda?.IdCurrency}
                  IdProveedor={values.Proveedor?.IdVendor}
                  habilitar={habilitar}
                  Functions={Functions}
                />
              </span>

            </div>
          </div>
        </div>
      </form>

      {showReporte && (
        <OrdenesComprasReporte1
          showReporte={showReporte}
          setShowReporte={setShowReporte}
          selectedDetalle={[values]}
          Language={Languaje}
          setLanguaje={setLanguaje}
        />
      )}
       
    </div>
  );
}

export default EncabezadoOrdenesCompras